import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

import SliderToggles from "./SliderToggles";

// style rules
import { Sizes, Colors } from "../../styles";

const Slide = ({
	slide,
	togglePrevSlide,
	toggleNexSlide,
	currentIndex,
	length,
}) => {
	return (
		<>
			<ImageSide>
				<ImageContainer>
					<img src={slide.image} />
				</ImageContainer>
				<SliderToggles
					slidesCount={length}
					// plus 1 to account for the array starting at 0
					currentSlide={currentIndex + 1}
					toggleNexSlide={toggleNexSlide}
					togglePrevSlide={togglePrevSlide}
				/>
			</ImageSide>
			<TextSide>
				{slide.title && <Title>{slide.title}</Title>}
				{slide.text && <Text>{slide.text}</Text>}
			</TextSide>
		</>
	);
};

Slide.propTypes = {
	slide: PropTypes.object,
	currentIndex: PropTypes.number,
	toggleNexSlide: PropTypes.func,
	togglePrevSlide: PropTypes.func,
	length: PropTypes.number,
};

export default Slide;

const ImageSide = styled.div`
	padding: 0 0 5.9rem 0;
	border-bottom: 2px ${Colors.grey.greyBorder} solid;

	@media only screen and (min-width: ${Sizes.screens.exhibitBreakpoint}) {
		padding: 5.9rem 5.9rem 0 0;
		border-right: 2px ${Colors.grey.greyBorder} solid;
		border-bottom: none;
	}
`;

const ImageContainer = styled.div`
	height: 0;
	overflow: hidden;
	padding-top: calc(448 / 736 * 100%);
	position: relative;
	width: 100%;

	img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

const TextSide = styled.div`
	max-width: 440px;
	align-self: center;
	padding-top: 3rem;

	@media only screen and (min-width: ${Sizes.screens.exhibitBreakpoint}) {
		padding-top: 0;
	}
`;

const Title = styled.h4``;

const Text = styled.p`
	padding-top: 2rem;
`;
